export const LOAD_ITEMS_LIMIT = 20
